import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// web/src/components/layout/AppShell.tsx
// Master layout wrapper: TopBar + main content area.
// Handles agent activity drawer state globally.
import { useState } from "react";
import { TopBar } from "./TopBar";
import { DisclosureFooter } from "./DisclosureFooter";
import { AgentActivityDrawer } from "./AgentActivityDrawer";
export function AppShell({ children, activityEvents = [], agentActivityCount = 0, }) {
    const [activityOpen, setActivityOpen] = useState(false);
    return (_jsxs("div", { className: "flex flex-col h-screen bg-slate-950 text-slate-200 overflow-hidden", children: [_jsx(TopBar, { onActivityClick: () => setActivityOpen(true), agentActivityCount: agentActivityCount }), _jsx("main", { className: "flex-1 overflow-hidden", children: children }), _jsx(DisclosureFooter, {}), _jsx(AgentActivityDrawer, { open: activityOpen, onClose: () => setActivityOpen(false), events: activityEvents })] }));
}
